import React, {Component} from 'react';
import {Redirect, Route, Switch} from 'react-router'
import {FourOFour} from "features/pages/404";
import LoginPage from "features/pages/account/login";
import ForgotPasswordPage from "features/pages/account/forgot-password";
import {initAuth} from "store/reducer/auth/reducer";
import {connect} from "react-redux";
import {isLoggedIn, needToChangeTempPassword, needToCompleteOnboarding} from "store/reducer/auth/selectors";
import {calculateRedirectBasedOnAuth} from "services/utils/utils";
import {LoggedInGuard, LoggedOutGuard, OnboardingGuard} from "features/router/guard";
import SignUpPage from "features/pages/account/signup";
import OnboardingPage from "features/pages/account/onboarding";
import HomePage from "features/pages/home";
import ProfilePage from "features/pages/profile";
import VideosPage from "features/pages/videos";
import SingleVideoPage from "features/pages/single-video";
import SingleDirectoryPage from "features/pages/single-directory";
import SingleEventPage from "features/pages/single-event";
import PaymentPage from "features/pages/payment";
import EventsPage from "features/pages/events";
import ProfilePublicPage from "features/pages/profile-public";
import AccountSettingsPage from "features/pages/settings";
import PrivacyPage from "features/pages/privacy";
import PageHelp from "features/pages/help";
import ResetPasswordPage from "features/pages/account/reset-password";
import ThreadsPage from "features/pages/threads";
import ThreadUpsertPage from "features/pages/thread-upsert";
import SingleThreadPage from "features/pages/single-thread";
import PeoplePage from "features/pages/people";
import SinglePeoplePage from "features/pages/single-people";
import ResetSuccess from "../pages/account/reset-success";
import AppCourtesyPage from "../pages/account/app-courtesy";

/* istanbul ignore next */
const mapStateToProps = state => ({
    isLoggedIn: isLoggedIn(state),
    hasTempPassword: needToChangeTempPassword(state),
    hasDoneOnboarding: !needToCompleteOnboarding(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    initAuth
};

export class Router extends Component {
    componentDidMount() {
        const {initAuth} = this.props;
        initAuth();
    }

    getSlashRedirect() {
        const {isLoggedIn, hasTempPassword, hasDoneOnboarding} = this.props;
        return calculateRedirectBasedOnAuth({isLoggedIn, hasTempPassword, hasDoneOnboarding});
    }

    render() {
        return (
            <>
                <Switch>
                    <Route path={"/"} exact>
                        <Redirect to={this.getSlashRedirect()}/>
                    </Route>
                    <Route path={"/login"} exact component={LoggedOutGuard(ForgotPasswordPage)} />
                    <Route path={"/reset-success"} exact component={LoggedOutGuard(ResetSuccess)} />
                    <Route path={"/forgot"} exact component={LoggedOutGuard(ForgotPasswordPage)} />
                    <Route path={"/app-courtesy"} exact component={AppCourtesyPage} />
                    <Route path={"/recovery/:token"} exact component={LoggedOutGuard(ResetPasswordPage)} />
                    <Route path={"/signup/:type"} component={LoggedOutGuard(SignUpPage)} />

                    <Route path={"/onboarding"} exact component={OnboardingGuard(OnboardingPage)} />

                    <Route path={"/home"} exact component={LoggedInGuard(HomePage)} />
                    <Route path={"/videos"} exact component={LoggedInGuard(VideosPage)} />
                    <Route path={"/events"} exact component={LoggedInGuard(EventsPage)} />
                    <Route path={"/threads"} exact component={LoggedInGuard(ThreadsPage)} />
                    <Route path={"/people"} exact component={LoggedInGuard(PeoplePage)} />

                    <Route path={"/threads/new"} exact component={LoggedInGuard(ThreadUpsertPage)} />
                    <Route path={"/threads/edit/:id"} exact component={LoggedInGuard(ThreadUpsertPage)} />
                    <Route path={"/threads/:id"} exact component={LoggedInGuard(SingleThreadPage)} />

                    <Route path={"/profile"} exact component={LoggedInGuard(ProfilePage)} />
                    <Route path={"/settings"} exact component={LoggedInGuard(AccountSettingsPage)} />
                    <Route path={"/privacy"} exact component={LoggedInGuard(PrivacyPage)} />

                    <Route path={"/video/:id"} exact component={LoggedInGuard(SingleVideoPage)} />
                    <Route path={"/directory/:id"} exact component={LoggedInGuard(SingleDirectoryPage)} />
                    <Route path={"/event/:id"} exact component={LoggedInGuard(SingleEventPage)} />

                    <Route path={"/payment/:type/:resource_id"} exact component={LoggedInGuard(PaymentPage)} />

                    <Route path={"/people/:slug"} exact component={LoggedInGuard(SinglePeoplePage)} />
                    <Route path={"/people/:slug/company/:company_id"} exact component={LoggedInGuard(SinglePeoplePage)} />

                    <Route path={"/p/:slug"} exact component={ProfilePublicPage} />

                    <Route path={"/help"} exact component={PageHelp}/>
                    <Route component={FourOFour} />
                </Switch>
            </>
        )
    }

}
export default connect(mapStateToProps, mapDispatchToProps)(Router);
